import { useNavigate } from 'react-router-dom';

import WebTokenManager from '../utils/WebTokenManager';

const useLogout = () => {
  const navigate = useNavigate();

  const handleLogout = (redirectUrl?: string | null) => {
    window.MinddPlugin.setOrgName(undefined);
    WebTokenManager.clear();
    if (redirectUrl) {
      navigate(`/login?redirectUrl=${redirectUrl}`);
    } else {
      navigate('/login');
    }
  };

  return { logout: handleLogout };
};

export default useLogout;
